<div class="flex flex-col w-full h-full justify-between items-center">

  <!-- Main Content -->
  <div class="flex flex-col w-full h-full justify-center items-center gap-12">

    <!-- Loading Icon -->
    <div class="flex flex-col justify-center items-center">
      <app-cloud-number [loading]="true"></app-cloud-number>
    </div>

    <!-- Loading texts -->
    <div class="flex flex-col justify-between items-center gap-4">
      <p class="text-gray text-[20px] font-medium">{{ checkName }} wird ausgeführt</p>
      <ng-container>
        <p class="text-gray text-[16px] font-medium">{{ currentLoadingMessage }}</p>
      </ng-container>
    </div>

    <!-- Info 1 -->
    <div class="flex flex-col justify-start items-center">
      <p class="text-gray text-[16px]">{{ loadingText }}</p>
      <p class="text-gray text-[16px]">Dies kann einen Moment dauern - bitte haben Sie einen Augenblick Geduld.</p>
    </div>

    <!-- Info 2 -->
    <div class="flex flex-row justify-between items-center gap-2">
      <fa-icon [icon]="faShieldCheck" class="text-gray-700"></fa-icon>
      <p class="text-gray-700 text-[14px] font-medium">DSGVO-konforme & verschlüsselte Datenverarbeitung</p>
    </div>

  </div>
</div>
